import { AxiosResponse, AxiosError, AxiosInstance } from 'axios';

const onResponse = (response: AxiosResponse) => response;
const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

export const setupInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
};
